module.exports = new __parcel__URL__("staffing-preview.cf56bfbb.svg").toString();